export const HousekeeperWorker = function () {
    // importScripts("https://cdn.jsdelivr.net/npm/lodash@4.17.21/lodash.min.js");

    const watch = (interval) => {
        postMessage(`check ${interval}`);
        setInterval(() => {
            postMessage(`check`);
        }, interval);
    };

    self.addEventListener("message", (event) => {
        // eslint-disable-line no-restricted-globals
        if (!event || !event.data) return;
        const interval = event.data || 60000;

        watch(interval);
    });
};
